import React from 'react';
// Styles
import '@/styles/commission.css';

export const Commission = () => {
    return (
        <main className="page-body">
            <div style={{ height: '100vh' }}>
                <h1 style={{ marginTop: 50, textAlign: 'center' }}>委託相關內容 Coming Soon...</h1>
            </div>
        </main>
    )
}
